import { FormEnginePlugin } from '@form-engine/core-application';
import Element, { apiName } from './components/button-element';

declare module '@form-engine/core-application/types/form' {
    interface ElementDefinitionSubType {
        [apiName]: {
            label?: string;
            action?: string;
            eventName?: string;
            isBlock?: boolean;
            variant?: string;
            size?: 'sm' | 'lg';
            url?: string;
            urlTarget?: string;
            pageName?: string;
            requireValid?: boolean;
            requireOnline?: boolean;
        };
    }
}

export default {
    elements: {
        [apiName]: Element,
    },
} as FormEnginePlugin;
